import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle, Home } from 'lucide-react';
import { Button } from '@/components/ui/button';

/**
 * Página exibida quando um token de convite já foi utilizado
 */
export default function InviteTokenUsedPage() {
  const navigate = useNavigate();

  useEffect(() => {
  }, []);

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted px-4">
      <div className="text-center space-y-6 max-w-md">
        <div className="w-48 h-48 mx-auto flex items-center justify-center relative">
          <div className="absolute inset-0 rounded-full bg-destructive/10 animate-pulse" />
          <XCircle className="relative w-20 h-20 text-destructive animate-bounce" style={{ animationDuration: '2s' }} />
        </div>
        
        <div className="space-y-3">
          <div className="flex items-center justify-center gap-2 text-destructive">
            <XCircle className="h-8 w-8" />
            <h1 className="text-3xl font-bold">Convite Já Utilizado</h1>
          </div>
          
          <p className="text-lg text-muted-foreground">
            Este link de convite já foi usado e não pode ser acessado novamente.
          </p>
          
          <p className="text-sm text-muted-foreground">
            Cada link de convite pode ser utilizado apenas uma vez por questões de segurança.
          </p>
        </div>

        <div className="pt-4">
          <p className="text-xs text-muted-foreground">
            Se você acredita que isso é um erro, entre em contato com o administrador.
          </p>
        </div>
      </div>
    </div>
  );
}
